import React from "react";
import MultiFilter from "@/components/MultiFilter";
import { statusMeta } from "@/lib/statusMeta";
import { X } from "lucide-react";

export default function FilterBar({ filters, setFilter, clearFilters, options, hide = [] }) {
  if (!options) return null;
  const active = Object.values(filters).some(Boolean);
  const show = (k) => !hide.includes(k);
  return (
    <div className="flex flex-wrap items-end gap-3">
      {show("warehouse") && <MultiFilter label="Warehouse" value={filters.warehouse} onChange={(v) => setFilter("warehouse", v)} options={options.warehouses} testId="filter-warehouse" />}
      {show("class") && <MultiFilter label="Class" value={filters.class} onChange={(v) => setFilter("class", v)} options={options.classes} testId="filter-class" />}
      {show("subclass") && <MultiFilter label="Subclass" value={filters.subclass} onChange={(v) => setFilter("subclass", v)} options={options.subclasses} testId="filter-subclass" />}
      {show("stocking_type") && <MultiFilter label="Stocking Type" value={filters.stocking_type} onChange={(v) => setFilter("stocking_type", v)} options={options.stocking_types} testId="filter-stocking" />}
      {show("item_classification") && <MultiFilter label="Commodity Class" value={filters.item_classification} onChange={(v) => setFilter("item_classification", v)} options={options.item_classifications} testId="filter-classification" />}
      {show("pref_supp") && <MultiFilter label="Preferred Supplier" value={filters.pref_supp} onChange={(v) => setFilter("pref_supp", v)} options={options.pref_supps} testId="filter-supplier" />}
      {show("status") && <MultiFilter label="Inventory Status" value={filters.status} onChange={(v) => setFilter("status", v)} options={options.statuses} render={(s) => statusMeta(s).label} testId="filter-status" />}
      {active && (
        <button onClick={clearFilters} data-testid="clear-filters" className="h-9 px-3 rounded-md text-[12px] font-medium text-slate-600 border border-[var(--line)] bg-white hover:bg-slate-50 flex items-center gap-1">
          <X className="w-3.5 h-3.5" /> Clear all
        </button>
      )}
    </div>
  );
}
